import Section from '../../elements/Section'
import Container from '../../elements/Container'
import Columns from '../../layout/Columns'
import Column from '../../layout/Column'
import Link from 'next/link'
import LazyImage from '../../elements/LazyImage'
import navigation from './navigation'
import styles from './styles.module.scss'
import Form from './components/Form'
import { useResponsive } from '../../../providers/ResponsiveContext'
import { withModifiers } from '../../helpers/withModifiers'
import { useRouter } from 'next/router'
import IconExternal from '/public/icons/icon-external.svg'
import Button from '../../elements/Button'
import has from 'lodash-es/has'
import moment from 'moment'

const Footer = ({ translations }) => {
  const { isTablet, isSmallMobile, isMobile } = useResponsive()
  const router = useRouter()

  const currentYear = moment().utc().year()

  return (
    <footer className={styles.footer}>
      <Section variant={['bg-body']}>
        <Container>
          <div className={styles.footer__section}>
            <Columns variant={['-align-middle', 'no-gutter']}>
              <Column
                variant={['no-padding']}
                spans={isSmallMobile ? 12 : isTablet ? 3 : 2}
              >
                <LazyImage
                  alt="Sotheby's Realty logo"
                  src="/logos/logo-stmartin-footer.svg"
                  width={116}
                  height={87}
                />
              </Column>

              <Column
                spans={isSmallMobile ? 12 : isMobile ? 9 : 7}
                variant={['grow', isSmallMobile && 'no-padding']}
              >
                <div className={styles.footer__title}>
                  {translations.subscribe[router.locale]}
                </div>

                <p className={styles.footer__description}>
                  {translations.description[router.locale]}
                </p>

                {isTablet && <Form translations={translations.form} />}
              </Column>
              {!isTablet && (
                <Column variant={['no-padding']} spans={isSmallMobile ? 12 : 3}>
                  <Form translations={translations.form} />
                </Column>
              )}
            </Columns>
          </div>

          <div className={styles.footer__section}>
            <Columns
              variant={[isTablet ? '-align-center' : '-distribute-between']}
              className={styles.footer__wrapper}
            >
              {navigation().map((column, index) => (
                <Column
                  className={styles.footer__column}
                  spans={isSmallMobile ? 6 : isTablet && 4}
                  key={`column-${index}`}
                >
                  <div className={styles.footer__heading}>
                    {column.title[router.locale]}
                  </div>

                  {column.links.map((item, value) => {
                    if (item) {
                      if (item.link) {
                        if (item.social) {
                          return (
                            <a
                              key={`link-${index}-${value}`}
                              className={withModifiers(
                                'footer__link',
                                [
                                  router.asPath === item.link && 'is-active',
                                  item.disabled && 'disabled'
                                ],
                                styles
                              )}
                              target="_blank"
                              href={item.link}
                              rel="noreferrer"
                            >
                              {item.title}

                              <IconExternal />
                            </a>
                          )
                        } else {
                          return (
                            <Link
                              key={`link-${index}-${value}`}
                              href={item.link}
                            >
                              <a
                                className={withModifiers(
                                  'footer__link',
                                  [
                                    router.asPath === item.link && 'is-active',
                                    item.disabled && 'disabled'
                                  ],
                                  styles
                                )}
                              >
                                {
                                  translations[
                                    item.title
                                      .toLowerCase()
                                      .replaceAll(' ', '')
                                      .replaceAll("'", '')
                                      .replaceAll('.', '')
                                  ]?.[router.locale]
                                }
                              </a>
                            </Link>
                          )
                        }
                      }

                      return (
                        <Button
                          key={`link-${index}-${value}`}
                          arrow={false}
                          variant={['label']}
                          onClick={() => item.action && item.action()}
                          className={withModifiers(
                            'footer__link',
                            [
                              router.asPath === item.link && 'is-active',
                              !has(item, 'action') && 'disabled'
                            ],
                            styles
                          )}
                        >
                          {item.title}
                        </Button>
                      )
                    }
                    return
                  })}
                </Column>
              ))}
            </Columns>
          </div>

          <div className={styles.footer__section}>
            <span>
              Copyright © {currentYear} {translations.copyright[router.locale]}
            </span>

            <p className={styles.footer__copyright}>
              <span className={styles.highlight}>
                {translations.copyrightHighlight[router.locale]}
              </span>{' '}
              {translations.copyrightDescription[router.locale]}
            </p>
          </div>
        </Container>
      </Section>
    </footer>
  )
}
export default Footer
